import { React, createContext } from "react";

export const Context = createContext();

export default function ContextProvider({children}) {

  const ambiente = 'PROD';// DEV / PROD
  const teste_em_producao = false;

  const dadosContext = {
    ambiente: ambiente,
    teste_em_producao: teste_em_producao
  }

  return (
    <Context.Provider value={dadosContext}>
      {children}
    </Context.Provider>
  )
}
